import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Validators } from 'ngx-editor';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { EmailService } from 'src/app/services/email.service';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styles: [
  ]
})
export class MyAccountComponent implements OnInit {

  public user;
  public password;

  public registerForm = this.fb.group({
    name: [''],
    surname: [''],
    alias: [''],
    email: [''],
    role: [''],
    phone:[''],
    profession:[''],
    company:[''],
    notes:[''],
    remainingTests:[''],
    country:[''],
    city:[''],
    sex:[''],
    birthDate:[''],

    isCustomBrand: [false],
    logoUrl: [''],
    logoLink: [''],
    customColor: [''],


  });

  public isSubscribed = false;
  public subscriptionEnd = new Date();

  constructor(
    private userService:UserService, 
    private fb:FormBuilder, 
    private emailService:EmailService,
    private testService: TestService,
    private adminService: AdminServiceService
    ) { 
    this.userService.getUser().subscribe(
      resp=>{
        this.user = resp;
        // this.registerForm.get('name').setValue(resp.name);
        // this.registerForm.get('surname').setValue(resp.surname);
        // this.registerForm.get('alias').setValue(resp.alias);
        // this.registerForm.get('email').setValue(resp.email);
        // this.registerForm.get('role').setValue(resp.role);
        // this.registerForm.get('phone').setValue(resp.phone);
        // this.registerForm.get('profession').setValue(resp.profession);
        // this.registerForm.get('company').setValue(resp.company);
        // this.registerForm.get('notes').setValue(resp.notes);
        // this.registerForm.get('remainingTests').setValue(resp.remainingTests);
        // this.registerForm.get('country').setValue(resp.country);
        // this.registerForm.get('city').setValue(resp.city);
        // this.registerForm.get('sex').setValue(resp.sex);
        this.registerForm.patchValue(resp);
        this.registerForm.get('birthDate').setValue(formatDate(resp.birthDate, 'yyyy-MM-dd', 'en'));


        if (this.user.canUseCustomTests){
          let today = new Date();
          let date = new Date(this.user.subscriptionEnd);
          this.isSubscribed = today < date;
        }


      },
      err=>console.log(err)
    )
  }

  ngOnInit(): void {
  }

  update(){
    this.userService.updateUser(this.registerForm.value).subscribe(
      resp=>{
        Swal.fire('Usuario actualizado',"", 'success').then(
          resp=>{
            window.location.reload();
          }
        )
      },
      err=>console.log(err)
    )
  }

  updatePassword(){

    this.userService.updateUser({email:this.user.email, password: this.password}).subscribe(
      resp=>{
        var data = {
          email:this.user.email,
          password:this.password
        }
        this.emailService.changePassword(data).subscribe();
        Swal.fire("Contraseña actualizada");

        this.password = "";
      },
      err=>console.log(err)
    )
    
  }

  resetRemainingDays(){
    this.userService.updateUser({email:this.user.email, lastPurchase:Date.now()}).subscribe(
      resp=>{
        Swal.fire("Actualizado");
      },
      err=>console.log(err)
    )
  }

  uploadImage(event: any){

    let suportedFormats = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!event.target.files[0]) return;
    if (!suportedFormats.includes(event.target.files[0].type)) {
      return Swal.fire({
        icon: 'error',
        text: 'Formato no soportado',

      })
    }
    if (event.target.files[0].size > 2500000) {
      return Swal.fire({
        icon: 'error',
        text: 'Imagen demasiado grande',

      })
    }

    const file = event.target.files[0];
    this.testService.uploadImage(file).subscribe(
      resp=>{
        console.log(resp.secure_url)
        this.registerForm.get('logoUrl').setValue(resp.secure_url);
      },
      err=>console.log(err)
    )
  }

  async shareBrandLink(){
    let url = `${location.origin}/login?uid=${this.user._id}`;
    await navigator.clipboard.writeText(url);
    Swal.fire({
      icon:'success',
      text:'Enlace copiado al portapapeles',
      showConfirmButton: false,
      timer: 1500
    })
  }

  formatDate(date: Date){
    return `${date.getDate()}/${date.getMonth()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
  }

  cancelSubscription(){
    if (this.user.useMp){
      this.adminService.cancelMpSubscription(this.user.subscriptionId).subscribe(
        resp => {
          this.userService.updateUser({email:this.user.email, subscriptionCancelled: true}).subscribe()
          Swal.fire('Cancelado', 'La suscripción ha sido cancelada. No podrás acceder a las pruebas luego de la fecha de fin de tu suscripción actual', 'success').then(
            resp => {
              window.location.reload();
            }
          )
        },
        err => {
          Swal.fire('Error', 'No se pudo cancelar la suscripción', 'error')
        }
      )
    }else{
      this.adminService.cancelPayPalSubscription(this.user.subscriptionId).subscribe(
        resp => {
          this.userService.updateUser({email:this.user.email, subscriptionCancelled: true}).subscribe()
          Swal.fire('Cancelado', 'La suscripción ha sido cancelada. No podrás acceder a las pruebas luego de la fecha de fin de tu suscripción actual', 'success').then(
            resp => {
              window.location.reload();
            }
          )
        },
        err => {
          Swal.fire('Error', 'No se pudo cancelar la suscripción', 'error')
        }
      )
    }
  }



}
